import { events_path, org_charts_path, subscribe_path, upgrade_subscription_path } from '@routes';

export const SUBSCRIBE_BUTTON_TEXT = 'Subscribe today';
export const UPGRADE_BUTTON_TEXT = 'Upgrade to Pro';

const ACCESS_IMG = 'https://tii.imgix.net/global/pro/access_image.png';
const DATA_IMG = 'https://tii.imgix.net/global/pro/data_image.png';
const INSIGHTS_IMG = 'https://tii.imgix.net/global/pro/insights_image.png';
const EVENTS_IMG = 'https://tii.imgix.net/global/pro/events_image.png';

export const ProPerks = {
  access: {
    title: 'Access',
    description:
      'Industry-specific org charts for more than 65 companies, built by our reporters for our newsroom and subscribers.',
    logoUrl: ACCESS_IMG,
    buttonText: 'Explore Org Charts',
    url: org_charts_path(),
  },
  data: {
    title: 'Data',
    description:
      'View a range of custom databases built by our journalists, offering previously unreported insights into startup funding, investors, and more.',
    logoUrl: DATA_IMG,
  },
  events: {
    title: 'Events',
    description:
      'Join subscriber-exclusive live conversations with industry experts to understand and navigate the biggest questions in tech and finance.',
    logoUrl: EVENTS_IMG,
    buttonText: 'Discover upcoming events',
    url: events_path(),
  },
  insights: {
    title: 'Insights',
    description:
      'Receive a curated weekly briefing from our expert journalists in your inbox every Friday, plus read Pro-exclusive articles and see the results of subscriber surveys.',
    logoUrl: INSIGHTS_IMG,
  },
};

export const ProFocusOnAIArticles = [
  {
    title: 'Generative AI',
    description:
      'We built a database of more than 600 companies making software and services that use generative AI. Together, these startups have raised over $187 billion. Our data comes from our reporting, founders, investors and PitchBook, which provides private market data.',
    slug: 'generative-ai',
  },
  {
    title: 'AI Data Center',
    description:
      'AI developers are racing to build the biggest and most powerful Nvidia server chip clusters to win in AI. We mapped 20+ of the biggest completed and planned server clusters.',
    slug: 'ai-data-center-database',
  },
  {
    title: 'AI Chip',
    description:
      'Makers of GPUs used to train and run AI models are key to understand the emerging AI landscape. We have compiled a list of 25+ startups working on AI chips, which have raised more than $10 billion from investors and are valued at a collective $38 billion.',
    slug: 'ai-chip-makers',
  },
];

export const getCTAPath = (isSubscriber: boolean, offer: string) => {
  if (isSubscriber) {
    return upgrade_subscription_path({ offer: offer });
  } else {
    return subscribe_path({ offer: offer });
  }
};
